/* Stillwach – Slide-in-Warenkorb: Upsells hinzufügen, Express-Regler, Lieferdatum. Lädt auf allen Seiten. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }

  function post(url, body) {
    var d = drawer();
    if (d) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Fehler');
        return j;
      });
    }).then(function (j) {
      if (d && j.sections) d.renderContents(j);
      else window.location.reload();
      return j;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sw-cart-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    post('cart/add.js', { items: [{ id: parseInt(b.dataset.swCartAdd, 10), quantity: 1 }] })
      .catch(function (err) { b.disabled = false; alert('Das hat nicht geklappt: ' + err.message); });
  });

  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-sw-priority]');
    if (!t) return;
    var box = t.closest('.sw-cart-prio');
    if (box) box.classList.add('is-busy');
    var req = t.checked
      ? post('cart/add.js', { items: [{ id: parseInt(t.dataset.swPriority, 10), quantity: 1 }] })
      : post('cart/change.js', { id: t.dataset.lineKey, quantity: 0 });
    req.catch(function (err) {
      t.checked = !t.checked;
      if (box) box.classList.remove('is-busy');
      alert('Das hat nicht geklappt: ' + err.message);
    });
  });

  /* Echtes Lieferdatum (Mo–Fr) im Warenkorb – nach jedem Neu-Rendern aktualisieren */
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }); }
  function updateDates() {
    document.querySelectorAll('[data-sw-cart-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10), max = parseInt(el.dataset.max, 10);
      if (!min) return;
      var now = new Date();
      var a = addBusinessDays(now, min), b = addBusinessDays(now, Math.max(min, max));
      var out = el.querySelector('[data-sw-cart-delivery-date]');
      var val = fmt(a) + (max > min ? ' – ' + fmt(b) : '');
      if (out && out.textContent !== val) out.textContent = val;
    });
  }
  function watch() {
    var d = drawer();
    updateDates();
    if (d && 'MutationObserver' in window) new MutationObserver(updateDates).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
